<mat-card>
  <mat-card-title fxLayout="row">
    <div fxFlex>Administrador de sucursales</div>
    <!-- <mat-slide-toggle [checked]="this.viewOnlyActive" (change)="changeOnlyActive()">Ver Sólo Activos</mat-slide-toggle> -->
  </mat-card-title>
  <mat-card-content>
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nombre </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="deleteBranch(element.id)">
          <mat-icon aria-label="Eliminar">delete</mat-icon>
        </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"> </mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  <mat-paginator [length]="dataSource.count" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
  </mat-card-content>
</mat-card>
